import React, { forwardRef, useImperativeHandle } from 'react';
import { Col, Row } from 'antd';
import { Wrapper } from './FooterBar.style'

const FooterBar = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
    }));

    return (
        <Wrapper style={{display: 'flex', background: (props.cor) ? props.cor : '#FFF', boxShadow:'rgba(0, 0, 0, 0.24) 0px 3px 8px'}}>
            <Row style={{height: '100%', width: '100%'}} gutter={24}>
                <Col span={1} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '0', backgroundColor: 'transparent'}}>
                        {/* FooterBar */}
                </Col>
            </Row>
        </Wrapper>
    );
});

export default FooterBar